import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { ComponentConfig, type Component } from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const ComponentItem: RelationFieldProps<Component> = {
  nested: getRelationFieldNames(ComponentConfig),
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex items-center',
          isRelationField && 'w-full justify-between'
        )}
      >
        <span>{item.componentType?.name ?? 'Ingen komponenttyp'}</span>
        {!isRelationField && <Dot />}
        <span>{item.serialNumber || 'Inget serienummer'}</span>
      </div>
    ),
  }),
};
